<template>
  <div id="AddSlideTitle" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回活動花絮列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>相簿名稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.title"
                  ref="inputData.title"
                  placeholder="請輸入相簿名稱"
                />
              </div>
            </td>
          </tr>
             <tr align="left">
            <td><span class="red_star">＊</span>拍攝時間

              <div>
                <b-input-group class="mb-3">
                  <b-form-input
                    id="inputData.updateTime"
                    v-model="inputData.updateTime"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    ref="inputData.updateTime"
                    autocomplete="off"
                    required
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="inputData.updateTime"
                      button-only
                      right
                      locale="zh-tw"
                      aria-controls="example-input"
                      @context="onContext"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </td>

          </tr>



        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddSlideTitle()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>


import * as tools from "../tool";

export default {
  name: "AddSlideTitle",

  data() {
    return {

      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        title:null,
        updateTime:null,
        UpdateUser:null,

      },
      currentPage: 1,
      cid: "",
      pageSize: 10,

    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },

  },

  methods: {

      empty(str) {
      if (
        typeof str == "undefined" ||
        !str ||
        str.length === 0 ||
        str === "" ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true;
      } else {
        return false;
      }
    },

    checkInput() {
      this.inputFlag = false;
      if (this.empty(this.inputData.title)) {
        alert("請輸入主旨");
        this.$refs["inputData.title"].focus();
        this.inputFlag = true;
        return;
      }

      if (this.empty(this.inputData.updateTime)) {
        alert("請輸入拍攝時間");
        this.$refs["inputData.updateTime"].focus();
        this.inputFlag = true;
        return;
      }


    },
    AddSlideTitle() {
      this.checkInput();
      this.inputData.UpdateUser = this.user.id;
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/ociaRep/AddSlideTitle/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加相簿成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加相簿失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    onContext(ctx) {
      // this.inputData.sdate = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created AddSlideTitleView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;

    // let vm = this;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
